<template>
    <ul class="inputs-ul" v-loading="loading">
        <li>
            <loginTextInput v-model="obj.login" />
        </li>

        <li>
            <div class="inline-box">
                <div class="inline-text-input">
                    <loginTextInput v-model="obj.name" :placeholder="i18n.tkey('lang_name')" />
                </div>

                <div class="inline-select">
                    <memmaleSelect v-model="obj.memmale" />
                </div>
            </div>
        </li>

        <li>
            <div class="inline-box">
                <div class="inline-select">
                    <areaNumberSelect v-model="obj.mpfaccount" />
                </div>

                <div class="inline-text-input">
                    <loginTextInput v-model="obj.telephone" />
                </div>
            </div>
        </li>

        <li style="padding-top: 5px">
            <span tkey="部門">{{i18n.tkey("lang_department")}}</span> <departmentSelect v-model="obj.department" />
        </li>

        <li style="padding-bottom: 10px">
            <span tkey="職位">{{i18n.tkey("lang_position")}}</span> <positionSelect v-model="obj.memposition" ref="positionSelectDom" />
        </li>

        <li>
            <loginPasswordInput v-model="obj.password" :placeholder="i18n.tkey('lang_password')" />
            <loginPasswordInput v-model="obj.repassword" :placeholder="i18n.tkey('lang_confirm_password')" />
        </li>

        <li style="text-align: center">
            <el-button type="primary" style="width: 250px; margin-bottom: 14px;" @click="clickSave" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
        </li>
    </ul>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, inject} from 'vue'
    import loginTextInput from "@/components/loginTextInput"
    import loginPasswordInput from "@/components/loginPasswordInput"
    import memmaleSelect from "@/components/shopopee/form/memmaleSelect"
    import areaNumberSelect from "@/components/shopopee/form/areaNumberSelect"
    import positionSelect from "@/components/shopopee/form/positionSelect"
    import departmentSelect from "@/components/shopopee/form/departmentSelect"
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";
    import {useUserinfo} from "@/stores/userinfo";
    import userApi from "@/request/userApi";

    const userInfoRef = toRef(useUserinfo())

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const obj = ref({
        addinfo3: null,
        companycode: null,
        department: null,
        login: null,
        memmale: 0,
        memposition: null,
        mpfaccount: "+852",
        name: null,
        password: 888888,
        repassword: 888888,
        positionname: null,
        telephone: null,
    })

    const loading = ref(false)

    function resetObj() {
        for (const key in obj.value){
            if (key == "department" || key == "memposition"){
                continue
            }

            obj.value[key] = null
        }

        obj.value.memmale = 0
        obj.value.mpfaccount = "+852"
        obj.value.password = "888888"
        obj.value.repassword = "888888"
    }

    function clickSave() {
        if (myUtil.isEmpty(obj.value.login)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (obj.value.password != obj.value.repassword){
            myUtil.alertWarning(i18n.tkey("lang_password_inconsistent"))
            return
        }

        if (myUtil.isEmpty(obj.value.name)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        if (myUtil.isEmpty(obj.value.telephone)){
            myUtil.alertWarning(i18n.tkey("lang_enter_complete"))
            return
        }

        const request = userApi.checkRegEmail
        const param = request.getParams()

        param.email = obj.value.login

        loading.value = true
        request.send(param, (res) => {
            if (res.code == 200){
                saveInfo()
            }else{
                loading.value = false
                myUtil.alertError(i18n.tkey("lang_user_email_has_reg"))
            }

        })


    }

    function saveInfo(){
        loading.value = true

        const selectObj = proxy.$refs.positionSelectDom.getPositionObj()

        const request = companyApi.addStaff
        const params = request.getParams()

        params.addinfo3 = userInfoRef.value.companyname
        params.companycode = userInfoRef.value.companycode
        params.department = obj.value.department
        params.login = obj.value.login
        params.memmale = obj.value.memmale
        params.memposition = obj.value.memposition
        params.mpfaccount = obj.value.mpfaccount
        params.name = obj.value.name
        params.password = obj.value.password
        params.positionname = selectObj.positionname
        params.telephone = obj.value.telephone

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                resetObj()
                myUtil.confirmSuccess(i18n.tkey("lang_add_staff_success_alert_text"))
            }else{
                myUtil.alertError(res.msg)
            }
        })
    }

    onMounted(() => {

    })

</script>

<style scoped>
    .inline-box {
        display: flex;
        align-items: center;
    }

    .inputs-ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
        overflow-x: hidden;
    }

    .inputs-ul li {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .inline-text-input {
        width: calc(100% - 100px);
        box-sizing: border-box;
    }

    .inline-select {
        width: 100px;
        box-sizing: border-box;
    }

    .inline-text-input+.inline-select{
        padding-left: 5px;
    }

    .inline-select+.inline-text-input{
        padding-left: 5px;
    }
</style>